import { lazy, memo, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';
import { getPromotionToolState } from '@/modules/main/selector';

const PromotionDialog = memo(
    lazy(() =>
        import('./PromotionDialog').then(({ PromotionDialog }) => ({
            default: PromotionDialog,
        }))
    )
);
const PromotionPopup = () => {
    const { HasEvent } = useSelector((state: RootState) =>
        getPromotionToolState(state)
    );
    return (
        <Suspense fallback={null}>{HasEvent && <PromotionDialog />}</Suspense>
    );
};
export const MemoizedPromotionPopup = memo(PromotionPopup);
